export interface Theme {
	id: string;
	category: string;
	emoji: string;
	themes: { id: string; title: string; emoji: string }[];
}

export const themeData: Theme[] = [
	{
		id: "qualification",
		category: "資格試験",
		emoji: "📚",
		themes: [
			{ id: "bookkeeping", title: "簿記検定", emoji: "📊" },
			{ id: "realEstate", title: "宅地建物取引士", emoji: "🏠" },
			{ id: "administrativeScrivener", title: "行政書士", emoji: "📝" },
			{ id: "laborConsultant", title: "社会保険労務士", emoji: "👥" },
			{ id: "smeBusinessConsultant", title: "中小企業診断士", emoji: "💼" },
			{ id: "itPassport", title: "ITパスポート", emoji: "💻" },
			{ id: "fundamentalIT", title: "基本情報技術者", emoji: "🖥️" },
			{ id: "appliedIT", title: "応用情報技術者", emoji: "🌐" },
			{ id: "cpa", title: "公認会計士", emoji: "🧮" },
			{ id: "taxAccountant", title: "税理士", emoji: "💰" },
		],
	},
	{
		id: "languageLearning",
		category: "語学学習",
		emoji: "🌍",
		themes: [
			{ id: "toeic", title: "TOEIC", emoji: "🌎" },
			{ id: "toefl", title: "TOEFL", emoji: "🎓" },
			{ id: "eiken", title: "英検", emoji: "🇬🇧" },
			{ id: "chineseTest", title: "中国語検定", emoji: "🇨🇳" },
			{ id: "koreanTest", title: "韓国語能力試験", emoji: "🇰🇷" },
			{ id: "germanTest", title: "ドイツ語検定", emoji: "🇩🇪" },
			{ id: "frenchTest", title: "フランス語検定", emoji: "🇫🇷" },
			{ id: "spanishTest", title: "スペイン語検定", emoji: "🇪🇸" },
			{ id: "jlpt", title: "日本語能力試験", emoji: "🇯🇵" },
		],
	},
	{
		id: "programming",
		category: "プログラミング",
		emoji: "💻",
		themes: [
			{ id: "javascript", title: "JavaScript", emoji: "💻" },
			{ id: "python", title: "Python", emoji: "🐍" },
			{ id: "java", title: "Java", emoji: "☕" },
			{ id: "cpp", title: "C++", emoji: "🔧" },
			{ id: "ruby", title: "Ruby", emoji: "💎" },
			{ id: "php", title: "PHP", emoji: "🐘" },
			{ id: "swift", title: "Swift", emoji: "🍎" },
			{ id: "go", title: "Go", emoji: "🐹" },
			{ id: "typescript", title: "TypeScript", emoji: "📘" },
			{ id: "rust", title: "Rust", emoji: "🦀" },
		],
	},
	{
		id: "design",
		category: "デザイン",
		emoji: "🎨",
		themes: [
			{ id: "uiUxDesign", title: "UI/UXデザイン", emoji: "🎨" },
			{ id: "graphicDesign", title: "グラフィックデザイン", emoji: "🖌️" },
			{ id: "webDesign", title: "Webデザイン", emoji: "🌐" },
			{ id: "illustration", title: "イラストレーション", emoji: "✏️" },
			{ id: "3dModeling", title: "3Dモデリング", emoji: "🗿" },
			{ id: "motionGraphics", title: "モーショングラフィックス", emoji: "🎬" },
		],
	},
	{
		id: "businessSkill",
		category: "ビジネススキル",
		emoji: "💼",
		themes: [
			{ id: "marketing", title: "マーケティング", emoji: "📊" },
			{ id: "projectManagement", title: "プロジェクト管理", emoji: "📅" },
			{ id: "leadership", title: "リーダーシップ", emoji: "👔" },
			{ id: "presentation", title: "プレゼンテーション", emoji: "🎤" },
			{ id: "businessEnglish", title: "ビジネス英語", emoji: "🌍" },
			{ id: "financialAnalysis", title: "財務分析", emoji: "💹" },
			{ id: "managementStrategy", title: "経営戦略", emoji: "🏆" },
		],
	},
	{
		id: "generalKnowledge",
		category: "教養・一般知識",
		emoji: "💡",
		themes: [
			{ id: "worldHistory", title: "世界史", emoji: "🌍" },
			{ id: "japanHistory", title: "日本史", emoji: "🏯" },
			{ id: "geography", title: "地理", emoji: "🗺️" },
			{ id: "politicsEconomy", title: "政治経済", emoji: "📰" },
			{ id: "literature", title: "文学", emoji: "📚" },
			{ id: "philosophy", title: "哲学", emoji: "🤔" },
			{ id: "psychology", title: "心理学", emoji: "🧠" },
			{ id: "science", title: "科学", emoji: "🔬" },
		],
	},
	{
		id: "hobbyPractical",
		category: "趣味・実用",
		emoji: "🛠️",
		themes: [
			{ id: "cooking", title: "料理", emoji: "👨‍🍳" },
			{ id: "gardening", title: "ガーデニング", emoji: "🌱" },
			{ id: "diy", title: "DIY", emoji: "🔨" },
			{ id: "photography", title: "写真撮影", emoji: "📷" },
			{ id: "musicPerformance", title: "楽器演奏", emoji: "🎸" },
			{ id: "handicraft", title: "手芸", emoji: "🧵" },
			{ id: "yoga", title: "ヨガ", emoji: "🧘" },
			{ id: "shogi", title: "将棋", emoji: "♟️" },
		],
	},
	{
		id: "studentLearning",
		category: "学生向け学習",
		emoji: "🎓",
		themes: [
			{ id: "math", title: "数学", emoji: "🔢" },
			{ id: "nationalLanguage", title: "国語", emoji: "📖" },
			{ id: "english", title: "英語", emoji: "🔤" },
			{ id: "science", title: "理科", emoji: "🧪" },
			{ id: "socialStudies", title: "社会", emoji: "🌏" },
			{ id: "shortEssay", title: "小論文", emoji: "✍️" },
			{ id: "examPreparation", title: "受験対策", emoji: "📝" },
			{
				id: "programmingIntroduction",
				title: "プログラミング入門",
				emoji: "👨‍💻",
			},
		],
	},
	{
		id: "creativity",
		category: "クリエイティブ",
		emoji: "🎭",
		themes: [
			{ id: "novelWriting", title: "小説執筆", emoji: "📘" },
			{ id: "poetry", title: "詩作", emoji: "🖋️" },
			{ id: "composition", title: "作曲", emoji: "🎵" },
			{ id: "videoProduction", title: "映像制作", emoji: "🎥" },
			{ id: "animation", title: "アニメーション", emoji: "🎬" },
			{ id: "podcastProduction", title: "ポッドキャスト制作", emoji: "🎙️" },
			{ id: "blogWriting", title: "ブログ執筆", emoji: "💻" },
			{
				id: "contentMarketing",
				title: "コンテンツマーケティング",
				emoji: "📱",
			},
		],
	},
	{
		id: "healthWellness",
		category: "健康・ウェルネス",
		emoji: "🧘‍♀️",
		themes: [
			{ id: "meditation", title: "瞑想", emoji: "🧘" },
			{ id: "stressManagement", title: "ストレス管理", emoji: "😌" },
			{ id: "nutrition", title: "栄養学", emoji: "🥗" },
			{ id: "fitness", title: "フィットネス", emoji: "🏋️" },
			{ id: "sleepImprovement", title: "睡眠改善", emoji: "😴" },
			{ id: "mindfulness", title: "マインドフルネス", emoji: "🌿" },
			{ id: "yoga", title: "ヨガ", emoji: "🧘‍♀️" },
			{ id: "pilates", title: "ピラティス", emoji: "🤸" },
		],
	},
	{
		id: "technology",
		category: "テクノロジー",
		emoji: "🚀",
		themes: [
			{ id: "artificialIntelligence", title: "人工知能", emoji: "🤖" },
			{ id: "blockchain", title: "ブロックチェーン", emoji: "🔗" },
			{ id: "iot", title: "IoT", emoji: "🏠" },
			{ id: "cloudComputing", title: "クラウドコンピューティング", emoji: "☁️" },
			{ id: "cyberSecurity", title: "サイバーセキュリティ", emoji: "🔒" },
			{ id: "vrAr", title: "VR/AR", emoji: "👓" },
			{ id: "5gCommunication", title: "5G通信", emoji: "📡" },
			{ id: "quantumComputing", title: "量子コンピューティング", emoji: "💻" },
		],
	},
];
